import { Navigate, Outlet, useLocation } from "react-router-dom"
import { ApiError } from "../lib/api"
import { useMe } from "../lib/hooks"
import { AppBar } from "./AppBar"
import { Button } from "./ui/button"
import { Card } from "./ui/card"
import { Spinner } from "./ui/spinner"

export function Layout() {
  const me = useMe()
  const location = useLocation()

  if (me.isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-canvas">
        <Spinner className="size-6" />
      </div>
    )
  }

  // 401 は api.ts 側で /login redirect 済 (短期的に isError=true で来るのを許容)。
  // 5xx / network down はエラー UI で retry を促す (login 強制は誤誘導)。
  if (me.isError) {
    const status = me.error instanceof ApiError ? me.error.status : null
    if (status !== 401) {
      const msg = me.error instanceof Error ? me.error.message : "認証状態の取得に失敗しました"
      return (
        <div className="flex min-h-screen items-center justify-center bg-canvas px-8">
          <Card className="flex max-w-md flex-col gap-4 p-8">
            <h2 className="text-lg font-semibold text-text-primary">接続エラー</h2>
            <p className="text-sm text-text-secondary">{msg}</p>
            <Button onClick={() => me.refetch()} size="sm">
              再試行
            </Button>
          </Card>
        </div>
      )
    }
  }

  if (!me.data?.authenticated) {
    const next = location.pathname + location.search
    const search = next && next !== "/" ? `?next=${encodeURIComponent(next)}` : ""
    return <Navigate to={`/login${search}`} replace />
  }

  return (
    <div className="flex min-h-screen flex-col bg-canvas">
      <AppBar />
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  )
}
